import { render, staticRenderFns } from "./SpecificationsTab.vue?vue&type=template&id=98d47846"
import script from "./SpecificationsTab.vue?vue&type=script&lang=js"
export * from "./SpecificationsTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports